<template>

    <b-row>

        <b-col>

            <b-row class="mb-3">

                <b-col sm="12" class="d-flex align-items-center justify-content-end">

                    <b-button variant="success" class="mr-1" @click=" selectVariable() ">Create New</b-button>
                    <b-button variant="info" @click=" loadTable() ">Show All</b-button>
                </b-col>
            </b-row>

            <div class="table-responsive">

                <b-table bordered striped hover show-empty
                    :items=" items "
                    :fields=" fields "
                    :current-page=" currentPage "
                    :per-page=" 0 "
                    :sort-by.sync=" sortBy "
                    :sort-desc.sync=" sortDesc "
                    :busy=" loading "
                >

                    <template v-slot:cell(actions)="row">

                        <b-btn v-b-tooltip.hover title="Edit Variable" class="mr-1" size="sm" variant="info" @click=" selectVariable( row.item ) "><i class="fa fa-edit"></i></b-btn>
                        <b-btn v-b-tooltip.hover title="Delete Variable" class="mr-1" size="sm" variant="danger" @click=" deleteVariable( row.item.id ) "><i class="fa fa-ban"></i></b-btn>
                    </template>
                </b-table>
            </div>

            <b-row>

                <b-col lg="6" >

                    <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                </b-col>
                <b-col lg="6" class="text-right">

                    {{ paginationText }}
                </b-col>
            </b-row>
        </b-col>

        <b-modal id="variableModal" title="Template Variable" v-model=" showModal " size="lg" no-close-on-backdrop>

            <b-container fluid>

                <b-row>

                    <b-col sm="8">

                        <b-form-group label="Slug" label-for="slug">

                            <b-form-input
                                id="slug"
                                name="slug"
                                type="text"
                                v-model=" variable.slug "
                            ></b-form-input>
                            <input-help :form=" variable " field="slug" text="What text are we looking to replace? Automatically applies # to both sides."></input-help>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" class="d-flex align-items-center justify-content-center">

                        <p class="text-muted">Known as: {{ computedVariable }}</p>
                    </b-col>
                    <b-col sm="12">

                        <b-form-group label="Variable Type" label-for="type">

                            <b-select name="type" id="type" v-model=" variable.type ">

                                <option value="free_text">Free Text</option>
                                <option value="recipient_name">Recipient Name</option>
                                <!-- <option value="provider_name">Provider Name</option>
                                <option value="claimant_name">Claimant Name</option> -->
                            </b-select>
                            <input-help :form=" variable " field="type" text=""></input-help>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">

                        <b-form-group label="Body" label-for="body">

                            <b-form-input
                                id="body"
                                name="body"
                                type="text"
                                v-model=" variable.body "
                                :disabled=" variable.type != 'free_text' "
                            ></b-form-input>
                            <input-help :form=" variable " field="body" text="What are we replacing that text with?"></input-help>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>

            <div slot="modal-footer">

                <b-btn class="mr-1" :disabled=" actionLoading " variant="default" @click=" showModal = false ">Close</b-btn>
                <b-btn class="mr-1" :disabled=" actionLoading || !variable.id " variant="danger" @click=" deleteVariable( variable.id ) ">Delete</b-btn>
                <b-btn variant="info" @click=" saveVariable() ">Save Variable</b-btn>
            </div>
        </b-modal>
    </b-row>
</template>

<script>

    import PaginatedTable from '../../mixins/PaginatedTable';

    export default {

        mixins : [ PaginatedTable ],
        data() {

            return {

                showModal     : false,

                actionLoading : false,
                variable      : new Form({

                    id   : null,
                    slug : '',
                    body : '',
                    type : 'free_text',
                }),

                perPage : 5,
                baseUrl : '/business/text_template_variables',

                fields : [

                    {
                        key: 'slug',
                        label: 'Title',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                        sortable: false
                    },
                ],
            }
        },

        computed: {

            computedVariable(){

                return `#${this.variable.slug}#`;
            }
        },

        methods: {

            setForm( passed = null ){

                this.variable = new Form({

                    id      : passed ? passed.id : null,
                    slug    : passed ? passed.slug : '',
                    body    : passed ? passed.body : '',
                    type    : passed ? passed.type : 'free_text'
                });
            },
            selectVariable( variable = null ){

                this.setForm( variable );
                this.showModal = true;
            },
            deleteVariable( id ){

                this.actionLoading = true;
                let form = new Form({});

                form.submit( 'delete', `${this.baseUrl}/${id}` )
                    .then( res => {

                        this.loadTable();
                        this.showModal = false;
                    })
                    .finally( () => {

                        this.actionLoading = false;
                    })
            },
            saveVariable(){

                const action = this.variable.id ? 'patch' : 'post';
                const url = this.baseUrl + ( this.variable.id ? `/${this.variable.id}` : '' );

                this.actionLoading = true;
                this.variable.submit( action, url )
                    .then( res => {

                        this.loadTable();
                        this.showModal = false;
                    })
                    .finally( () => {

                        this.actionLoading = false;
                    });
            }
        }
    }
</script>

<style>

</style>